// This file is auto-generated. Do not edit directly.
const theme = {
    "color-*": "initial",
    "font-sans": "'Plus Jakarta Sans', Helvetica, sans-serif",
    "font-serif": "'Plus Jakarta Sans', Helvetica, sans-serif",
    "color-green-50": "oklch(97.4% 0.024 167.1)",
    "color-green-50-hex": "#e8fcf3",
    "color-green-50-rgba": "rgba(91.003%, 98.829%, 95.305%)",
    "color-green-100": "oklch(95.5% 0.044 165.3)",
    "color-green-100-hex": "#d6fae9",
    "color-green-100-rgba": "rgba(83.851%, 98.099%, 91.371%)",
    "color-green-200": "oklch(91.4% 0.085 164.5)",
    "color-green-200-hex": "#adf5d4",
    "color-green-200-rgba": "rgba(67.837%, 96.137%, 83.179%)",
    "color-green-300": "oklch(87.9% 0.125 162)",
    "color-green-300-hex": "#84f1be",
    "color-green-300-rgba": "rgba(51.722%, 94.509%, 74.474%)",
    "color-green-400": "oklch(84.7% 0.159 159.7)",
    "color-green-400-hex": "#59eca8",
    "color-green-400-rgba": "rgba(35.096%, 92.548%, 65.817%)",
    "color-green-500": "oklch(82.1% 0.186 156.5)",
    "color-green-500-hex": "#30e791",
    "color-green-500-rgba": "rgba(18.96%, 90.586%, 56.845%)",
    "color-green-600": "oklch(73.6% 0.178 155.1)",
    "color-green-600-hex": "#15c976",
    "color-green-600-rgba": "rgba(8.2075%, 78.855%, 46.238%)",
    "color-green-700": "oklch(59.6% 0.141 155.5)",
    "color-green-700-hex": "#149759",
    "color-green-700-rgba": "rgba(7.6502%, 59.154%, 34.909%)",
    "color-green-800": "oklch(44.7% 0.104 155.9)",
    "color-green-800-hex": "#0c653b",
    "color-green-800-rgba": "rgba(4.6057%, 39.554%, 23.088%)",
    "color-green-900": "oklch(28.2% 0.06 158.6)",
    "color-green-900-hex": "#06321e",
    "color-green-900-rgba": "rgba(2.2281%, 19.631%, 11.749%)",
    "color-green-950": "oklch(18.3% 0.035 160.4)",
    "color-green-950-hex": "#03170d",
    "color-green-950-rgba": "rgba(1.1259%, 8.9809%, 5.047%)",
    "color-blue-50": "oklch(98.1% 0.019 204.9)",
    "color-blue-50-hex": "#ebfdff",
    "color-blue-50-rgba": "rgba(92.117%, 99.155%, 99.942%)",
    "color-blue-100": "oklch(96.1% 0.038 206.8)",
    "color-blue-100-hex": "#d6faff",
    "color-blue-100-rgba": "rgba(83.831%, 98.05%, 100%)",
    "color-blue-200": "oklch(92.4% 0.076 206.3)",
    "color-blue-200-hex": "#a9f5ff",
    "color-blue-200-rgba": "rgba(66.152%, 96.098%, 100%)",
    "color-blue-300": "oklch(88.8% 0.111 206.8)",
    "color-blue-300-hex": "#75efff",
    "color-blue-300-rgba": "rgba(46.035%, 93.735%, 99.991%)",
    "color-blue-400": "oklch(85.7% 0.136 208.6)",
    "color-blue-400-hex": "#3ce8ff",
    "color-blue-400-rgba": "rgba(23.709%, 91.023%, 100%)",
    "color-blue-500": "oklch(83.7% 0.145 211.2)",
    "color-blue-500-hex": "#05e2ff",
    "color-blue-500-rgba": "rgba(1.832%, 88.581%, 100.01%)",
    "color-blue-600": "oklch(73.2% 0.127 211.4)",
    "color-blue-600-hex": "#02bdd6",
    "color-blue-600-rgba": "rgba(0.88431%, 74.054%, 83.847%)",
    "color-blue-700": "oklch(58.7% 0.102 210.6)",
    "color-blue-700-hex": "#008c9e",
    "color-blue-700-rgba": "rgba(0%, 54.946%, 62.044%)",
    "color-blue-800": "oklch(44.5% 0.077 209.7)",
    "color-blue-800-hex": "#005f6b",
    "color-blue-800-rgba": "rgba(0%, 37.296%, 42.018%)",
    "color-blue-900": "oklch(27.2% 0.047 208.6)",
    "color-blue-900-hex": "#002d33",
    "color-blue-900-rgba": "rgba(0%, 17.66%, 20.026%)",
    "color-blue-950": "oklch(18.6% 0.032 202.2)",
    "color-blue-950-hex": "#001719",
    "color-blue-950-rgba": "rgba(0%, 9.0054%, 9.8003%)",
    "color-yellow-50": "oklch(98.4% 0.027 95.3)",
    "color-yellow-50-hex": "#fffae6",
    "color-yellow-50-rgba": "rgba(100%, 98.084%, 90.155%)",
    "color-yellow-100": "oklch(97% 0.055 97.3)",
    "color-yellow-100-hex": "#fff6cc",
    "color-yellow-100-rgba": "rgba(100%, 96.514%, 80.073%)",
    "color-yellow-200": "oklch(94% 0.105 96.8)",
    "color-yellow-200-hex": "#ffec99",
    "color-yellow-200-rgba": "rgba(99.998%, 92.514%, 59.921%)",
    "color-yellow-300": "oklch(91.6% 0.145 96.7)",
    "color-yellow-300-hex": "#ffe368",
    "color-yellow-300-rgba": "rgba(99.978%, 89.068%, 40.635%)",
    "color-yellow-400": "oklch(89.1% 0.171 95.4)",
    "color-yellow-400-hex": "#fed934",
    "color-yellow-400-rgba": "rgba(99.59%, 85.085%, 20.253%)",
    "color-yellow-500": "oklch(87.2% 0.178 92.6)",
    "color-yellow-500-hex": "#fed004",
    "color-yellow-500-rgba": "rgba(99.563%, 81.576%, 1.5962%)",
    "color-yellow-600": "oklch(73.7% 0.151 92.7)",
    "color-yellow-600-hex": "#cba600",
    "color-yellow-600-rgba": "rgba(79.636%, 65.079%, 0%)",
    "color-yellow-700": "oklch(59.8% 0.122 93.6)",
    "color-yellow-700-hex": "#987d02",
    "color-yellow-700-rgba": "rgba(59.643%, 49.047%, 0.84659%)",
    "color-yellow-800": "oklch(44.8% 0.092 93.6)",
    "color-yellow-800-hex": "#665300",
    "color-yellow-800-rgba": "rgba(39.948%, 32.507%, 0%)",
    "color-yellow-900": "oklch(28.6% 0.059 96.5)",
    "color-yellow-900-hex": "#332a00",
    "color-yellow-900-rgba": "rgba(19.953%, 16.421%, 0%)",
    "color-yellow-950": "oklch(19.5% 0.041 100.4)",
    "color-yellow-950-hex": "#191500",
    "color-yellow-950-rgba": "rgba(9.8683%, 8.2715%, 0%)",
    "color-red-50": "oklch(95.9% 0.017 17.5)",
    "color-red-50-hex": "#fdeded",
    "color-red-50-rgba": "rgba(99.151%, 93.01%, 93.006%)",
    "color-red-100": "oklch(90.8% 0.039 17.9)",
    "color-red-100-hex": "#fad7d7",
    "color-red-100-rgba": "rgba(97.948%, 84.272%, 84.27%)",
    "color-red-200": "oklch(82.8% 0.077 18.8)",
    "color-red-200-hex": "#f5b3b3",
    "color-red-200-rgba": "rgba(96.017%, 70.222%, 70.238%)",
    "color-red-300": "oklch(74.1% 0.123 20.4)",
    "color-red-300-hex": "#ef8a8a",
    "color-red-300-rgba": "rgba(93.605%, 54.131%, 54.153%)",
    "color-red-400": "oklch(67% 0.167 22.7)",
    "color-red-400-hex": "#ea6464",
    "color-red-400-rgba": "rgba(91.733%, 39.125%, 39.101%)",
    "color-red-500": "oklch(60.3% 0.211 26.3)",
    "color-red-500-hex": "#e43535",
    "color-red-500-rgba": "rgba(89.364%, 20.747%, 20.742%)",
    "color-red-600": "oklch(52.9% 0.203 27.8)",
    "color-red-600-hex": "#c61a1b",
    "color-red-600-rgba": "rgba(77.649%, 10.35%, 10.459%)",
    "color-red-700": "oklch(42.9% 0.162 27.5)",
    "color-red-700-hex": "#941414",
    "color-red-700-rgba": "rgba(58.131%, 7.7945%, 7.8739%)",
    "color-red-800": "oklch(32.4% 0.119 27)",
    "color-red-800-hex": "#630d0d",
    "color-red-800-rgba": "rgba(38.87%, 4.9884%, 5.0497%)",
    "color-red-900": "oklch(21% 0.068 25.2)",
    "color-red-900-hex": "#310707",
    "color-red-900-rgba": "rgba(19.231%, 2.7574%, 2.7661%)",
    "color-red-950": "oklch(13.9% 0.039 23.7)",
    "color-red-950-hex": "#160303",
    "color-red-950-rgba": "rgba(8.606%, 1.1881%, 1.1858%)",
    "color-gold-50": "oklch(98.1% 0.004 106.5)",
    "color-gold-50-hex": "#f9f9f6",
    "color-gold-50-rgba": "rgba(97.61%, 97.611%, 96.422%)",
    "color-gold-100": "oklch(95.6% 0.011 106.6)",
    "color-gold-100-hex": "#f1f1e9",
    "color-gold-100-rgba": "rgba(94.528%, 94.528%, 91.272%)",
    "color-gold-200": "oklch(91.6% 0.019 103.4)",
    "color-gold-200-hex": "#e5e4d6",
    "color-gold-200-rgba": "rgba(89.843%, 89.439%, 83.868%)",
    "color-gold-300": "oklch(84.6% 0.035 103.5)",
    "color-gold-300-hex": "#d0ceb4",
    "color-gold-300-rgba": "rgba(81.557%, 80.773%, 70.624%)",
    "color-gold-400": "oklch(77.2% 0.051 103.7)",
    "color-gold-400-hex": "#bab792",
    "color-gold-400-rgba": "rgba(72.92%, 71.739%, 57.085%)",
    "color-gold-500": "oklch(69.7% 0.067 104)",
    "color-gold-500-hex": "#a4a06f",
    "color-gold-500-rgba": "rgba(64.326%, 62.744%, 43.542%)",
    "color-gold-600": "oklch(60.1% 0.065 105)",
    "color-gold-600-hex": "#868355",
    "color-gold-600-rgba": "rgba(52.55%, 51.369%, 33.206%)",
    "color-gold-700": "oklch(49.7% 0.052 103.9)",
    "color-gold-700-hex": "#676441",
    "color-gold-700-rgba": "rgba(40.439%, 39.246%, 25.441%)",
    "color-gold-800": "oklch(37.8% 0.037 103.8)",
    "color-gold-800-hex": "#45432c",
    "color-gold-800-rgba": "rgba(27.048%, 26.256%, 17.143%)",
    "color-gold-900": "oklch(24.5% 0.02 103.4)",
    "color-gold-900-hex": "#222116",
    "color-gold-900-rgba": "rgba(13.323%, 12.927%, 8.5672%)",
    "color-gold-950": "oklch(16.8% 0.01 98)",
    "color-gold-950-hex": "#100f0a",
    "color-gold-950-rgba": "rgba(6.2921%, 5.9071%, 3.9707%)",
    "color-brown-50": "oklch(95.2% 0.004 17.2)",
    "color-brown-50-hex": "#f2eeee",
    "color-brown-50-rgba": "rgba(94.792%, 93.335%, 93.335%)",
    "color-brown-100": "oklch(91% 0.009 17.3)",
    "color-brown-100-hex": "#e7dfdf",
    "color-brown-100-rgba": "rgba(90.659%, 87.432%, 87.433%)",
    "color-brown-200": "oklch(81.8% 0.018 17.5)",
    "color-brown-200-hex": "#cfbfbf",
    "color-brown-200-rgba": "rgba(81.155%, 74.925%, 74.927%)",
    "color-brown-300": "oklch(72.4% 0.028 17.8)",
    "color-brown-300-hex": "#b79f9f",
    "color-brown-300-rgba": "rgba(71.733%, 62.432%, 62.434%)",
    "color-brown-400": "oklch(61.8% 0.041 18.3)",
    "color-brown-400-hex": "#9d7c7c",
    "color-brown-400-rgba": "rgba(61.554%, 48.651%, 48.655%)",
    "color-brown-500": "oklch(52.2% 0.042 18.6)",
    "color-brown-500-hex": "#806060",
    "color-brown-500-rgba": "rgba(50.26%, 37.665%, 37.663%)",
    "color-brown-600": "oklch(42.7% 0.033 18.5)",
    "color-brown-600-hex": "#604848",
    "color-brown-600-rgba": "rgba(37.624%, 28.2%, 28.205%)",
    "color-brown-700": "oklch(32.7% 0.023 18.4)",
    "color-brown-700-hex": "#403030",
    "color-brown-700-rgba": "rgba(24.993%, 18.831%, 18.831%)",
    "color-brown-800": "oklch(26.1% 0.017 18.3)",
    "color-brown-800-hex": "#2c2121",
    "color-brown-800-rgba": "rgba(17.276%, 12.961%, 12.96%)",
    "color-brown-900": "oklch(17.5% 0.008 18)",
    "color-brown-900-hex": "#140f0f",
    "color-brown-900-rgba": "rgba(7.7877%, 5.9319%, 5.9303%)",
    "color-brown-950": "oklch(14.4% 0.005 17.8)",
    "color-brown-950-hex": "#0c0909",
    "color-brown-950-rgba": "rgba(4.6704%, 3.5678%, 3.567%)",
    "color-gray-50": "oklch(96.4% 0.001 106.4)",
    "color-gray-50-hex": "#f3f3f2",
    "color-gray-50-rgba": "rgba(95.302%, 95.302%, 95.006%)",
    "color-gray-100": "oklch(92.5% 0.003 84.6)",
    "color-gray-100-hex": "#e7e6e4",
    "color-gray-100-rgba": "rgba(90.581%, 90.176%, 89.365%)",
    "color-gray-200": "oklch(85.8% 0.004 91.5)",
    "color-gray-200-hex": "#d1d0cd",
    "color-gray-200-rgba": "rgba(81.995%, 81.627%, 80.52%)",
    "color-gray-300": "oklch(77.9% 0.007 97.4)",
    "color-gray-300-hex": "#b8b7b2",
    "color-gray-300-rgba": "rgba(72.176%, 71.789%, 69.85%)",
    "color-gray-400": "oklch(70.1% 0.011 100.9)",
    "color-gray-400-hex": "#a09f97",
    "color-gray-400-rgba": "rgba(62.722%, 62.347%, 59.347%)",
    "color-gray-500": "oklch(62.5% 0.013 101.6)",
    "color-gray-500-hex": "#89887f",
    "color-gray-500-rgba": "rgba(53.724%, 53.34%, 49.884%)",
    "color-gray-600": "oklch(53% 0.012 101)",
    "color-gray-600-hex": "#6d6c64",
    "color-gray-600-rgba": "rgba(42.767%, 42.385%, 39.324%)",
    "color-gray-700": "oklch(43.7% 0.01 106.8)",
    "color-gray-700-hex": "#52524c",
    "color-gray-700-rgba": "rgba(32.204%, 32.204%, 29.76%)",
    "color-gray-800": "oklch(33.6% 0.007 95.3)",
    "color-gray-800-hex": "#383733",
    "color-gray-800-rgba": "rgba(21.919%, 21.529%, 19.961%)",
    "color-gray-900": "oklch(21.8% 0.004 84.6)",
    "color-gray-900-hex": "#1b1a18",
    "color-gray-900-rgba": "rgba(10.564%, 10.186%, 9.4283%)",
    "color-gray-950": "oklch(15.9% 0.002 106.6)",
    "color-gray-950-hex": "#0d0d0c",
    "color-gray-950-rgba": "rgba(5.1272%, 5.127%, 4.7488%)",
    "color-primary-50": "oklch(97.4% 0.024 167.1)",
    "color-primary-50-hex": "#e8fcf3",
    "color-primary-50-rgba": "rgba(91.003%, 98.829%, 95.305%)",
    "color-primary-100": "oklch(95.5% 0.044 165.3)",
    "color-primary-100-hex": "#d6fae9",
    "color-primary-100-rgba": "rgba(83.851%, 98.099%, 91.371%)",
    "color-primary-200": "oklch(91.4% 0.085 164.5)",
    "color-primary-200-hex": "#adf5d4",
    "color-primary-200-rgba": "rgba(67.837%, 96.137%, 83.179%)",
    "color-primary-300": "oklch(87.9% 0.125 162)",
    "color-primary-300-hex": "#84f1be",
    "color-primary-300-rgba": "rgba(51.722%, 94.509%, 74.474%)",
    "color-primary-400": "oklch(84.7% 0.159 159.7)",
    "color-primary-400-hex": "#59eca8",
    "color-primary-400-rgba": "rgba(35.096%, 92.548%, 65.817%)",
    "color-primary-500": "oklch(82.1% 0.186 156.5)",
    "color-primary-500-hex": "#30e791",
    "color-primary-500-rgba": "rgba(18.96%, 90.586%, 56.845%)",
    "color-primary-600": "oklch(73.6% 0.178 155.1)",
    "color-primary-600-hex": "#15c976",
    "color-primary-600-rgba": "rgba(8.2075%, 78.855%, 46.238%)",
    "color-primary-700": "oklch(59.6% 0.141 155.5)",
    "color-primary-700-hex": "#149759",
    "color-primary-700-rgba": "rgba(7.6502%, 59.154%, 34.909%)",
    "color-primary-800": "oklch(44.7% 0.104 155.9)",
    "color-primary-800-hex": "#0c653b",
    "color-primary-800-rgba": "rgba(4.6057%, 39.554%, 23.088%)",
    "color-primary-900": "oklch(28.2% 0.06 158.6)",
    "color-primary-900-hex": "#06321e",
    "color-primary-900-rgba": "rgba(2.2281%, 19.631%, 11.749%)",
    "color-primary-950": "oklch(18.3% 0.035 160.4)",
    "color-primary-950-hex": "#03170d",
    "color-primary-950-rgba": "rgba(1.1259%, 8.9809%, 5.047%)",
    "color-secondary-50": "oklch(98.1% 0.019 204.9)",
    "color-secondary-50-hex": "#ebfdff",
    "color-secondary-50-rgba": "rgba(92.117%, 99.155%, 99.942%)",
    "color-secondary-100": "oklch(96.1% 0.038 206.8)",
    "color-secondary-100-hex": "#d6faff",
    "color-secondary-100-rgba": "rgba(83.831%, 98.05%, 100%)",
    "color-secondary-200": "oklch(92.4% 0.076 206.3)",
    "color-secondary-200-hex": "#a9f5ff",
    "color-secondary-200-rgba": "rgba(66.152%, 96.098%, 100%)",
    "color-secondary-300": "oklch(88.8% 0.111 206.8)",
    "color-secondary-300-hex": "#75efff",
    "color-secondary-300-rgba": "rgba(46.035%, 93.735%, 99.991%)",
    "color-secondary-400": "oklch(85.7% 0.136 208.6)",
    "color-secondary-400-hex": "#3ce8ff",
    "color-secondary-400-rgba": "rgba(23.709%, 91.023%, 100%)",
    "color-secondary-500": "oklch(83.7% 0.145 211.2)",
    "color-secondary-500-hex": "#05e2ff",
    "color-secondary-500-rgba": "rgba(1.832%, 88.581%, 100.01%)",
    "color-secondary-600": "oklch(73.2% 0.127 211.4)",
    "color-secondary-600-hex": "#02bdd6",
    "color-secondary-600-rgba": "rgba(0.88431%, 74.054%, 83.847%)",
    "color-secondary-700": "oklch(58.7% 0.102 210.6)",
    "color-secondary-700-hex": "#008c9e",
    "color-secondary-700-rgba": "rgba(0%, 54.946%, 62.044%)",
    "color-secondary-800": "oklch(44.5% 0.077 209.7)",
    "color-secondary-800-hex": "#005f6b",
    "color-secondary-800-rgba": "rgba(0%, 37.296%, 42.018%)",
    "color-secondary-900": "oklch(27.2% 0.047 208.6)",
    "color-secondary-900-hex": "#002d33",
    "color-secondary-900-rgba": "rgba(0%, 17.66%, 20.026%)",
    "color-secondary-950": "oklch(18.6% 0.032 202.2)",
    "color-secondary-950-hex": "#001719",
    "color-secondary-950-rgba": "rgba(0%, 9.0054%, 9.8003%)",
    "color-tertiary-50": "oklch(95.2% 0.004 17.2)",
    "color-tertiary-50-hex": "#f2eeee",
    "color-tertiary-50-rgba": "rgba(94.792%, 93.335%, 93.335%)",
    "color-tertiary-100": "oklch(91% 0.009 17.3)",
    "color-tertiary-100-hex": "#e7dfdf",
    "color-tertiary-100-rgba": "rgba(90.659%, 87.432%, 87.433%)",
    "color-tertiary-200": "oklch(81.8% 0.018 17.5)",
    "color-tertiary-200-hex": "#cfbfbf",
    "color-tertiary-200-rgba": "rgba(81.155%, 74.925%, 74.927%)",
    "color-tertiary-300": "oklch(72.4% 0.028 17.8)",
    "color-tertiary-300-hex": "#b79f9f",
    "color-tertiary-300-rgba": "rgba(71.733%, 62.432%, 62.434%)",
    "color-tertiary-400": "oklch(61.8% 0.041 18.3)",
    "color-tertiary-400-hex": "#9d7c7c",
    "color-tertiary-400-rgba": "rgba(61.554%, 48.651%, 48.655%)",
    "color-tertiary-500": "oklch(52.2% 0.042 18.6)",
    "color-tertiary-500-hex": "#806060",
    "color-tertiary-500-rgba": "rgba(50.26%, 37.665%, 37.663%)",
    "color-tertiary-600": "oklch(42.7% 0.033 18.5)",
    "color-tertiary-600-hex": "#604848",
    "color-tertiary-600-rgba": "rgba(37.624%, 28.2%, 28.205%)",
    "color-tertiary-700": "oklch(32.7% 0.023 18.4)",
    "color-tertiary-700-hex": "#403030",
    "color-tertiary-700-rgba": "rgba(24.993%, 18.831%, 18.831%)",
    "color-tertiary-800": "oklch(26.1% 0.017 18.3)",
    "color-tertiary-800-hex": "#2c2121",
    "color-tertiary-800-rgba": "rgba(17.276%, 12.961%, 12.96%)",
    "color-tertiary-900": "oklch(17.5% 0.008 18)",
    "color-tertiary-900-hex": "#140f0f",
    "color-tertiary-900-rgba": "rgba(7.7877%, 5.9319%, 5.9303%)",
    "color-tertiary-950": "oklch(14.4% 0.005 17.8)",
    "color-tertiary-950-hex": "#0c0909",
    "color-tertiary-950-rgba": "rgba(4.6704%, 3.5678%, 3.567%)",
    "color-tapp-green": "oklch(82.1% 0.186 156.5)",
    "color-tapp-green-hex": "#30e791",
    "color-tapp-green-rgba": "rgba(18.96%, 90.586%, 56.845%)",
    "color-tapp-blue": "oklch(85.7% 0.136 208.6)",
    "color-tapp-blue-hex": "#3ce8ff",
    "color-tapp-blue-rgba": "rgba(23.709%, 91.023%, 100%)",
    "color-tapp-darkgreen": "oklch(44.7% 0.104 155.9)",
    "color-tapp-darkgreen-hex": "#0c653b",
    "color-tapp-darkgreen-rgba": "rgba(4.6057%, 39.554%, 23.088%)",
    "color-tapp-brown": "oklch(32.7% 0.023 18.4)",
    "color-tapp-brown-hex": "#403030",
    "color-tapp-brown-rgba": "rgba(24.993%, 18.831%, 18.831%)",
    "color-system-light": "oklch(100% 0 0)",
    "color-system-light-hex": "#fff",
    "color-system-light-rgba": "rgba(100%, 100%, 100%)",
    "color-system-dark": "oklch(18.6% 0.032 202.2)",
    "color-system-dark-hex": "#001719",
    "color-system-dark-rgba": "rgba(0%, 9.0054%, 9.8003%)",
    "color-transparent": "transparent",
    "color-transparent-light-10": "oklch(100% 0 0 / 0.1)",
    "color-transparent-light-10-hex": "#ffffff1a",
    "color-transparent-light-10-rgba": "rgba(100%, 100%, 100%, 0.1)",
    "color-transparent-light-25": "oklch(100% 0 0 / 0.25)",
    "color-transparent-light-25-hex": "#ffffff40",
    "color-transparent-light-25-rgba": "rgba(100%, 100%, 100%, 0.25)",
    "color-transparent-light-50": "oklch(100% 0 0 / 0.5)",
    "color-transparent-light-50-hex": "#ffffff80",
    "color-transparent-light-50-rgba": "rgba(100%, 100%, 100%, 0.5)",
    "color-transparent-light-75": "oklch(100% 0 0 / 0.75)",
    "color-transparent-light-75-hex": "#ffffffbf",
    "color-transparent-light-75-rgba": "rgba(100%, 100%, 100%, 0.75)",
    "color-transparent-light-90": "oklch(100% 0 0 / 0.9)",
    "color-transparent-light-90-hex": "#ffffffe6",
    "color-transparent-light-90-rgba": "rgba(100%, 100%, 100%, 0.9)",
    "color-transparent-dark-10": "oklch(18.6% 0.032 202.2 / 0.1)",
    "color-transparent-dark-10-hex": "#0017191a",
    "color-transparent-dark-10-rgba": "rgba(0%, 9.0054%, 9.8003%, 0.1)",
    "color-transparent-dark-25": "oklch(18.6% 0.032 202.2 / 0.25)",
    "color-transparent-dark-25-hex": "#00171940",
    "color-transparent-dark-25-rgba": "rgba(0%, 9.0054%, 9.8003%, 0.25)",
    "color-transparent-dark-50": "oklch(18.6% 0.032 202.2 / 0.5)",
    "color-transparent-dark-50-hex": "#00171980",
    "color-transparent-dark-50-rgba": "rgba(0%, 9.0054%, 9.8003%, 0.5)",
    "color-transparent-dark-75": "oklch(18.6% 0.032 202.2 / 0.75)",
    "color-transparent-dark-75-hex": "#001719bf",
    "color-transparent-dark-75-rgba": "rgba(0%, 9.0054%, 9.8003%, 0.75)",
    "color-transparent-dark-90": "oklch(18.6% 0.032 202.2 / 0.9)",
    "color-transparent-dark-90-hex": "#001719e6",
    "color-transparent-dark-90-rgba": "rgba(0%, 9.0054%, 9.8003%, 0.9)",
    "color-error-50": "oklch(95.9% 0.017 17.5)",
    "color-error-50-hex": "#fdeded",
    "color-error-50-rgba": "rgba(99.151%, 93.01%, 93.006%)",
    "color-error-100": "oklch(90.8% 0.039 17.9)",
    "color-error-100-hex": "#fad7d7",
    "color-error-100-rgba": "rgba(97.948%, 84.272%, 84.27%)",
    "color-error-200": "oklch(82.8% 0.077 18.8)",
    "color-error-200-hex": "#f5b3b3",
    "color-error-200-rgba": "rgba(96.017%, 70.222%, 70.238%)",
    "color-error-300": "oklch(74.1% 0.123 20.4)",
    "color-error-300-hex": "#ef8a8a",
    "color-error-300-rgba": "rgba(93.605%, 54.131%, 54.153%)",
    "color-error-400": "oklch(67% 0.167 22.7)",
    "color-error-400-hex": "#ea6464",
    "color-error-400-rgba": "rgba(91.733%, 39.125%, 39.101%)",
    "color-error-500": "oklch(60.3% 0.211 26.3)",
    "color-error-500-hex": "#e43535",
    "color-error-500-rgba": "rgba(89.364%, 20.747%, 20.742%)",
    "color-error-600": "oklch(52.9% 0.203 27.8)",
    "color-error-600-hex": "#c61a1b",
    "color-error-600-rgba": "rgba(77.649%, 10.35%, 10.459%)",
    "color-error-700": "oklch(42.9% 0.162 27.5)",
    "color-error-700-hex": "#941414",
    "color-error-700-rgba": "rgba(58.131%, 7.7945%, 7.8739%)",
    "color-error-800": "oklch(32.4% 0.119 27)",
    "color-error-800-hex": "#630d0d",
    "color-error-800-rgba": "rgba(38.87%, 4.9884%, 5.0497%)",
    "color-error-900": "oklch(21% 0.068 25.2)",
    "color-error-900-hex": "#310707",
    "color-error-900-rgba": "rgba(19.231%, 2.7574%, 2.7661%)",
    "color-error-950": "oklch(13.9% 0.039 23.7)",
    "color-error-950-hex": "#160303",
    "color-error-950-rgba": "rgba(8.606%, 1.1881%, 1.1858%)",
    "color-warning-50": "oklch(98.4% 0.027 95.3)",
    "color-warning-50-hex": "#fffae6",
    "color-warning-50-rgba": "rgba(100%, 98.084%, 90.155%)",
    "color-warning-100": "oklch(97% 0.055 97.3)",
    "color-warning-100-hex": "#fff6cc",
    "color-warning-100-rgba": "rgba(100%, 96.514%, 80.073%)",
    "color-warning-200": "oklch(94% 0.105 96.8)",
    "color-warning-200-hex": "#ffec99",
    "color-warning-200-rgba": "rgba(99.998%, 92.514%, 59.921%)",
    "color-warning-300": "oklch(91.6% 0.145 96.7)",
    "color-warning-300-hex": "#ffe368",
    "color-warning-300-rgba": "rgba(99.978%, 89.068%, 40.635%)",
    "color-warning-400": "oklch(89.1% 0.171 95.4)",
    "color-warning-400-hex": "#fed934",
    "color-warning-400-rgba": "rgba(99.59%, 85.085%, 20.253%)",
    "color-warning-500": "oklch(87.2% 0.178 92.6)",
    "color-warning-500-hex": "#fed004",
    "color-warning-500-rgba": "rgba(99.563%, 81.576%, 1.5962%)",
    "color-warning-600": "oklch(73.7% 0.151 92.7)",
    "color-warning-600-hex": "#cba600",
    "color-warning-600-rgba": "rgba(79.636%, 65.079%, 0%)",
    "color-warning-700": "oklch(59.8% 0.122 93.6)",
    "color-warning-700-hex": "#987d02",
    "color-warning-700-rgba": "rgba(59.643%, 49.047%, 0.84659%)",
    "color-warning-800": "oklch(44.8% 0.092 93.6)",
    "color-warning-800-hex": "#665300",
    "color-warning-800-rgba": "rgba(39.948%, 32.507%, 0%)",
    "color-warning-900": "oklch(28.6% 0.059 96.5)",
    "color-warning-900-hex": "#332a00",
    "color-warning-900-rgba": "rgba(19.953%, 16.421%, 0%)",
    "color-warning-950": "oklch(19.5% 0.041 100.4)",
    "color-warning-950-hex": "#191500",
    "color-warning-950-rgba": "rgba(9.8683%, 8.2715%, 0%)",
    "color-success-50": "oklch(97.4% 0.024 167.1)",
    "color-success-50-hex": "#e8fcf3",
    "color-success-50-rgba": "rgba(91.003%, 98.829%, 95.305%)",
    "color-success-100": "oklch(95.5% 0.044 165.3)",
    "color-success-100-hex": "#d6fae9",
    "color-success-100-rgba": "rgba(83.851%, 98.099%, 91.371%)",
    "color-success-200": "oklch(91.4% 0.085 164.5)",
    "color-success-200-hex": "#adf5d4",
    "color-success-200-rgba": "rgba(67.837%, 96.137%, 83.179%)",
    "color-success-300": "oklch(87.9% 0.125 162)",
    "color-success-300-hex": "#84f1be",
    "color-success-300-rgba": "rgba(51.722%, 94.509%, 74.474%)",
    "color-success-400": "oklch(84.7% 0.159 159.7)",
    "color-success-400-hex": "#59eca8",
    "color-success-400-rgba": "rgba(35.096%, 92.548%, 65.817%)",
    "color-success-500": "oklch(82.1% 0.186 156.5)",
    "color-success-500-hex": "#30e791",
    "color-success-500-rgba": "rgba(18.96%, 90.586%, 56.845%)",
    "color-success-600": "oklch(73.6% 0.178 155.1)",
    "color-success-600-hex": "#15c976",
    "color-success-600-rgba": "rgba(8.2075%, 78.855%, 46.238%)",
    "color-success-700": "oklch(59.6% 0.141 155.5)",
    "color-success-700-hex": "#149759",
    "color-success-700-rgba": "rgba(7.6502%, 59.154%, 34.909%)",
    "color-success-800": "oklch(44.7% 0.104 155.9)",
    "color-success-800-hex": "#0c653b",
    "color-success-800-rgba": "rgba(4.6057%, 39.554%, 23.088%)",
    "color-success-900": "oklch(28.2% 0.06 158.6)",
    "color-success-900-hex": "#06321e",
    "color-success-900-rgba": "rgba(2.2281%, 19.631%, 11.749%)",
    "color-success-950": "oklch(18.3% 0.035 160.4)",
    "color-success-950-hex": "#03170d",
    "color-success-950-rgba": "rgba(1.1259%, 8.9809%, 5.047%)",
    "color-surface-background": "oklch(98.1% 0.004 106.5)",
    "color-surface-background-hex": "#f9f9f6",
    "color-surface-background-rgba": "rgba(97.61%, 97.611%, 96.422%)",
    "color-surface-contained": "oklch(91.6% 0.019 103.4)",
    "color-surface-contained-hex": "#e5e4d6",
    "color-surface-contained-rgba": "rgba(89.843%, 89.439%, 83.868%)",
    "color-surface-border": "oklch(91.6% 0.019 103.4)",
    "color-surface-border-hex": "#e5e4d6",
    "color-surface-border-rgba": "rgba(89.843%, 89.439%, 83.868%)",
    "color-surface-border-contained": "oklch(84.6% 0.035 103.5)",
    "color-surface-border-contained-hex": "#d0ceb4",
    "color-surface-border-contained-rgba": "rgba(81.557%, 80.773%, 70.624%)",
    "color-surface-selected": "oklch(98.4% 0.027 95.3)",
    "color-surface-selected-hex": "#fffae6",
    "color-surface-selected-rgba": "rgba(100%, 98.084%, 90.155%)",
    "text-color-contrast": "oklch(100% 0 0)",
    "text-color-contrast-hex": "#fff",
    "text-color-contrast-rgba": "rgba(100%, 100%, 100%)",
    "text-color-default": "oklch(27.2% 0.047 208.6)",
    "text-color-default-hex": "#002d33",
    "text-color-default-rgba": "rgba(0%, 17.66%, 20.026%)",
    "text-color-sub": "oklch(62.5% 0.013 101.6)",
    "text-color-sub-hex": "#89887f",
    "text-color-sub-rgba": "rgba(53.724%, 53.34%, 49.884%)",
    "text-color-inactive": "oklch(85.8% 0.004 91.5)",
    "text-color-inactive-hex": "#d1d0cd",
    "text-color-inactive-rgba": "rgba(81.995%, 81.627%, 80.52%)",
    "text-color-link": "oklch(73.2% 0.127 211.4)",
    "text-color-link-hex": "#02bdd6",
    "text-color-link-rgba": "rgba(0.88431%, 74.054%, 83.847%)",
    "color-neutral-50": "oklch(96.4% 0.001 106.4)",
    "color-neutral-50-hex": "#f3f3f2",
    "color-neutral-50-rgba": "rgba(95.302%, 95.302%, 95.006%)",
    "color-neutral-100": "oklch(95.6% 0.011 106.6)",
    "color-neutral-100-hex": "#f1f1e9",
    "color-neutral-100-rgba": "rgba(94.528%, 94.528%, 91.272%)",
    "color-neutral-200": "oklch(91.6% 0.019 103.4)",
    "color-neutral-200-hex": "#e5e4d6",
    "color-neutral-200-rgba": "rgba(89.843%, 89.439%, 83.868%)",
    "color-neutral-300": "oklch(84.6% 0.035 103.5)",
    "color-neutral-300-hex": "#d0ceb4",
    "color-neutral-300-rgba": "rgba(81.557%, 80.773%, 70.624%)",
    "color-neutral-400": "oklch(70.1% 0.011 100.9)",
    "color-neutral-400-hex": "#a09f97",
    "color-neutral-400-rgba": "rgba(62.722%, 62.347%, 59.347%)",
    "color-neutral-500": "oklch(62.5% 0.013 101.6)",
    "color-neutral-500-hex": "#89887f",
    "color-neutral-500-rgba": "rgba(53.724%, 53.34%, 49.884%)",
    "color-neutral-600": "oklch(53% 0.012 101)",
    "color-neutral-600-hex": "#6d6c64",
    "color-neutral-600-rgba": "rgba(42.767%, 42.385%, 39.324%)",
    "text-2xs": "0.625rem",
    "text-xs": "0.75rem",
    "text-sm": "0.875rem",
    "text-base": "1rem",
    "text-lg": "1.125rem",
    "text-xl": "1.25rem",
    "text-2xl": "1.5rem",
    "text-3xl": "1.875rem",
    "text-4xl": "2.25rem",
    "text-5xl": "3rem",
    "text-2xs--line-height": "1.4",
    "text-xs--line-height": "1.4",
    "text-sm--line-height": "1.4",
    "text-base--line-height": "1.4",
    "text-lg--line-height": "1.2",
    "text-xl--line-height": "1.2",
    "text-2xl--line-height": "1.2",
    "text-3xl--line-height": "1.2",
    "text-4xl--line-height": "1.1",
    "text-5xl--line-height": "1",
    "shadow-inner": "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
    "shadow-sm": "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
    "shadow": "0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.1)",
    "shadow-md": "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.1)",
    "shadow-lg": "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.1)",
    "shadow-xl": "0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.1)",
    "shadow-2xl": "0px 25px 50px -12px rgba(0, 0, 0, 0.25)",
    "shadow-up-sm": "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
    "shadow-up": "0px -1px 3px 0px rgba(0, 0, 0, 0.1), 0px -1px 2px 0px rgba(0, 0, 0, 0.1)",
    "shadow-up-md": "0px -4px 6px -1px rgba(0, 0, 0, 0.1), 0px -2px 4px -1px rgba(0, 0, 0, 0.1)",
    "shadow-up-lg": "0px -10px 15px -3px rgba(0, 0, 0, 0.1), 0px -4px 6px -2px rgba(0, 0, 0, 0.1)",
    "shadow-up-xl": "0px -20px 25px -5px rgba(0, 0, 0, 0.1), 0px -10px 10px -5px rgba(0, 0, 0, 0.1)",
    "shadow-up-2xl": "0px -25px 50px -12px rgba(0, 0, 0, 0.25)",
    "animate-appear": "appear 100ms ease-in-out",
    "animate-gradient-loading": "gradient-loading 2s linear infinite"
};
export default theme;
